<script>
import pagination from "laravel-vue-pagination";
import { contactService } from "../../services";
import { debounce, success_message, error_message } from "../../Helper/helper";

export default {
  components: {  pagination },

  data() {
    const { status,orderBy,sortBy} = this.$route.query;
    return {
      items: [],
      sortBy: sortBy || "id",
      sortDesc: orderBy && orderBy != '' ? true : orderBy,
      loading: true,
      paginations: {},
      limit: 1,
      search: "",
      status: status == undefined ? '1' :status,
      searchData: debounce(() => {
        if (!this.init) {
          const {status,orderBy,sortBy} = this.$data;
          this.$router.replace({
            name: "contacts-list",
            query: {status,orderBy,sortBy},
          });
        }
        this.getContacts();
        this.init = false;
      }, 500),
      loading: true,
      paginations: {},
      limit: 1,
      fields: [
        { key: "id", label: "Id", sortable: true },
        { key: "type", label: "Type", sortable: true },
        { key: "company_name", label: "Company Name", sortable: true },
        { key: "user_name", label: "First Name & Last Name", sortable: true },
        { key: "email", label: "Email", sortable: true },
        { key: "phone_number1", label: "Phone Number", sortable: true },
        { key: "mobile_phone_number", label: "Mobile Phone Number", sortable: true },
        { key: "url", label: "Website-URL/Application-URL", sortable: true },
        { key: "status", label: "Status", sortable: false, thClass: "dis-event" },
        { key: "action", label: "Action", sortable: false, thClass: "dis-event" },
      ],
    };
  },
  methods: {
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.getContacts();
    },
    getContacts(page = 1) {
      contactService.getContact({
        search: this.search,
        status: this.status,
        sortBy: this.sortBy,
        orderBy: this.sortDesc ? "desc" : "asc",
        page: page && page > 0 ? page : 1,
      })
      .then((response) => {
        this.loading = false;
        this.paginations = response.data.result;
        this.items = response.data.result.data;
      })
      .catch(() => {
        this.loading = false;
        error_message("Failed to load contacts.");
      });
    },
    deleteContact(id) {
      if (confirm("Are you sure you want to delete this contact?")) {
        contactService.deleteContact({ id })
          .then((response) => {
            if (response.data.code === 200) {
              success_message(response.data.message);
              this.getContacts();
            } else {
              error_message(response.data.message);
            }
          })
          .catch(() => {
            error_message("Failed to delete contact.");
          });
      }
    },
  },
  mounted() {
    this.init = true; // Initialize the flag to control searchData behavior
    this.getContacts();
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div
          class="
            page-title-box
            d-flex
            align-items-center
            justify-content-between
            icon-main-page
          "
        >
          <div class="page-title-left">
            <div class="avatar-xs mr-3">
              <span
                class="
                  avatar-title
                  rounded-circle
                  bg-soft-primary
                  text-primary
                  font-size-18
                "
              >
                <i class="bx bx-user-circle"></i>
              </span>
            </div>
            <h4 class="mb-0 font-size-18">
              {{ trans.get("__JSON__.Contacts") }}
            </h4>
          </div>
          <div class="page-title-right d-flex">
            <router-link
              :to="{ name: 'contact-add' }"
              class="btn btn-success btn-rounded mr-2 add-btn"
            >
              <i class="mdi mdi-plus mr-1"></i>
              {{ trans.get("__JSON__.Add Contact") }}
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="row list-table-main">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
                <div class="col-sm-2 offset-sm-8">
                    <div class="form-group">
                        <div class="date-range-list">
                            <label>{{ trans.get('__JSON__.Status') }} :</label>
                            <select class="custom-select" v-model="status" @change="searchData()">
                            <option value="">{{ trans.get('__JSON__.All') }}</option>
                            <option value="1" selected>{{ trans.get('__JSON__.Active') }}</option>
                            <option value="0">{{ trans.get('__JSON__.Inactive') }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="col-sm-2">
                    <div class="date-range-list">
                        <label>{{ trans.get('__JSON__.Search') }} :</label>
                        <div class="text-sm-right">
                            <div class="search-box mr-2 d-inline-block">
                                <div class="position-relative">
                                    <input
                                    type="text"
                                    class="form-control"
                                    id="search"
                                    @input="searchData()"
                                    v-model="search"
                                    :placeholder="trans.get('__JSON__.Search Placeholder')"
                                    />
                                    <i class="bx bx-search-alt search-icon"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
              <div
                class="col-12 table-main-list product-table table-responsive"
              >
                <b-table
                  :items="items"
                  :fields="fields"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :no-local-sorting="true"
                  @sort-changed="sortingChanged"
                  :busy="loading"
                  show-empty
                >
                  <template v-slot:cell(type)="data">
                    {{ data.item.type === 0 ? "Person" : "Organization" }}
                  </template>
                  <template v-slot:cell(company_name)="data">
                    {{ data.item.company_name }}
                  </template>
                  <template v-slot:cell(status)="data">
                    <div
                      v-if="data.item.status === 0"
                      class="badge badge-pill badge-soft-danger font-size-12"
                    >
                      {{ trans.get("__JSON__.Inactive") }}
                    </div>
                    <div
                      v-else
                      class="badge badge-pill badge-soft-success font-size-12"
                    >
                      {{ trans.get("__JSON__.Active") }}
                    </div>
                  </template>
                  <template v-slot:cell(first_name)="data">
                    {{
                      data.item.first_name.charAt(0).toUpperCase() +
                      data.item.first_name.slice(1)

                    }}
                  </template>
                  <template v-slot:cell(action)="data">
                    <router-link
                      :to="{
                        name: 'contact-edit',
                        params: { id: base64(data.item.id) },
                      }"
                      class="btn btn-success btn-sm btn-rounded"
                      >Edit</router-link
                    >
                    <button
                      type="submit"
                      @click="deleteContact(base64(data.item.id))"
                      class="btn btn-danger btn-sm btn-rounded ml-1"
                    >
                      {{ trans.get("__JSON__.Delete") }}
                    </button>
                  </template>

                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>{{ trans.get("__JSON__.Loading...") }}</strong>
                    </div>
                  </template>

                  <template #empty>
                    <p class="text-center">
                      {{ trans.get("__JSON__.No Records Found") }}
                    </p>
                  </template>
                </b-table>
              </div>
              <div class="row col-sm-5 offset-sm-7">
                <div class="col">
                  <div
                    class="
                      dataTables_paginate
                      paging_simple_numbers
                      float-right
                    "
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <!-- <pagination
                        :data="paginations"
                        :limit="limit"
                        @pagination-change-page="getDeals"
                      ></pagination> -->
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
